import { render, staticRenderFns } from "./WaiterTemplateDiffInputItem.vue?vue&type=template&id=5ffa6e73&scoped=true&lang=pug"
import script from "./WaiterTemplateDiffInputItem.vue?vue&type=script&lang=ts"
export * from "./WaiterTemplateDiffInputItem.vue?vue&type=script&lang=ts"
import style0 from "./WaiterTemplateDiffInputItem.vue?vue&type=style&index=0&id=5ffa6e73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa6e73",
  null
  
)

export default component.exports